/**
 * I due hub di configurazione condividono componente e logica: cambia solo questa tabella.
 *  - `configurazione`: hub «Configurazione» (GET /api/v2/configurazione/hub);
 *  - `admin`: hub «Configurazione Admin» (GET /api/v2/configurazione/hub-admin), per le funzioni di piattaforma.
 */
export type HubId = 'configurazione' | 'admin'

export interface HubConfig {
  id: HubId
  /** Endpoint di lettura dell'indice (ConfigurazioneHubDTO). */
  endpoint: string
  /** Foglia del menu e radice della route: `<radice>/:area?` porta a un'area. */
  radice: string
  /** Nome della route dell'indice (param `area`). */
  routeName: string
  /** Nome del tour (flag «visto» sul server). */
  tourName: string
}

export const HUB: Record<HubId, HubConfig> = {
  configurazione: {
    id: 'configurazione',
    endpoint: '/api/v2/configurazione/hub',
    radice: '/configurazione',
    routeName: 'configurazione',
    tourName: 'configurazione-hub',
  },
  admin: {
    id: 'admin',
    endpoint: '/api/v2/configurazione/hub-admin',
    radice: '/configurazione-admin',
    routeName: 'configurazione-admin',
    tourName: 'configurazione-hub-admin',
  },
}

export const HUB_IDS: HubId[] = ['configurazione', 'admin']
